<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="90%">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="hidden-sm-and-down" v-bind="attrs" v-on="on" color="primary" dark
          :disabled="!plano.id || !temRecessos" alt="Resumo Recessos"
          @click="abrirResumo()" title="Resumo de Recessos">
          <v-icon>assessment</v-icon>Resumo
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Resumo de Recessos</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md2>
                <v-text-field color="primary" label="Ano" disabled :value="plano.ano"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field color="primary" label="Número" disabled :value="plano.numero"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field color="primary" label="Data Início" disabled :value="plano.dataInicio"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field color="primary" label="Data Fim" disabled :value="plano.dataFim"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-text-field color="primary" label="Descrição do Plano" disabled :value="plano.descricao"></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider class="my-3"></v-divider>
            <v-data-table :loading="loading" :headers="headers" :items="resumo" class="elevation-1" hide-actions>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.funcao }}</td>
                <td class="text-xs-center">{{ props.item.qhDom }}</td>
                <td class="text-xs-center">{{ props.item.qhSeg }}</td>
                <td class="text-xs-center">{{ props.item.qhTer }}</td>
                <td class="text-xs-center">{{ props.item.qhQua }}</td>
                <td class="text-xs-center">{{ props.item.qhQui }}</td>
                <td class="text-xs-center">{{ props.item.qhSex }}</td>
                <td class="text-xs-center">{{ props.item.qhSab }}</td>
                <td class="text-xs-center"><strong>{{ props.item.total }}</strong></td>
              </template>
              <template slot="no-data">
                Sem registros para somar.
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="close">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import qhRecessoService from "@/service/qh/QhRecessoService";
export default {
  name: "ModalResumoQhRecesso",
  props: {
    plano: { type: Object, default: () => ({}) },
    temRecessos: { type: Boolean, default: false }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      resumo: [],
      headers: [
        { text: "Função", align: "left", sortable: false, value: "funcao" },
        { text: "Dom", align: "center", sortable: false, value: "qhDom" },
        { text: "Seg", align: "center", sortable: false, value: "qhSeg" },
        { text: "Ter", align: "center", sortable: false, value: "qhTer" },
        { text: "Qua", align: "center", sortable: false, value: "qhQua" },
        { text: "Qui", align: "center", sortable: false, value: "qhQui" },
        { text: "Sex", align: "center", sortable: false, value: "qhSex" },
        { text: "Sab", align: "center", sortable: false, value: "qhSab" },
        { text: "Total", align: "center", sortable: false, value: "total" }
      ]
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    async abrirResumo() {
      this.loading = true;
      this.resumo = await qhRecessoService.resumoPorPlano(this.plano.id);
      this.loading = false;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.resumo = [];
      }, 300);
    }
  }
};
</script>
